var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.pdf-style-0{fill:#949494;}\n\t.pdf-style-1{fill:#F1F1F1;}\n\t.pdf-style-2{fill:#808080;}\n\t.pdf-style-3{fill:#DC1D00;}\n\t.pdf-style-4{fill:#4D4D4D;}\n\t.pdf-style-5{fill:#FFFEFE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_19_",
    className: "pdf-style-0",
    points: "404.25,1.26 404.11,1.26 505.95,107.45 505.95,510.74 125.81,510.74 125.81,512  507.21,512 507.21,108.71 404.25,1.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_20_",
    className: "pdf-style-1",
    points: "402.85,0 124.54,0 124.54,510.74 505.95,510.74 505.95,107.45 402.85,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_39_",
    className: "pdf-style-2",
    points: "121.74,27.35 4.89,27.35 4.89,152.2 121.74,152.2 372.41,152.2 372.41,27.35  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_30_",
    x: 7.27,
    y: 25.25,
    className: "pdf-style-3",
    width: 367.1,
    height: 124.98
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "pdf-style-4",
    d: "M125.53,88.23c-0.56,0-1.12,0-1.68,0V61.16h3.51c4.07,0,6.59,1.26,8.42,3.37 c2.24,2.52,3.37,7.01,3.37,10.24c0,4.49,0,8.56-4.07,11.5C132.96,87.81,129.45,88.23,125.53,88.23 M129.03,46.29 c-0.14,0-0.42,0-0.56,0c-1.82,0-3.09,0-3.79,0h-19.5v87.81h18.8v-29.6l4.21,0.28c4.35,0,8.28-0.98,11.78-2.1 c3.51-1.12,6.45-3.09,8.98-5.33c2.52-2.24,4.91-5.05,6.17-8.28c1.96-4.91,2.38-11.78,1.96-16.55c-0.56-4.77-0.7-8.7-2.1-11.78 c-1.4-3.09-3.23-5.61-5.33-7.57c-2.24-1.96-4.63-3.37-7.15-4.35c-2.67-0.98-5.05-1.54-7.57-1.96 C132.68,46.43,130.72,46.29,129.03,46.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "pdf-style-4",
    d: "M189.35,118.11c-0.56,0-1.12,0-1.82,0V62.14c0.14,0,0.14,0,0.28,0c3.79,0,8.56,0,10.94,1.96 c2.52,1.96,4.49,4.49,5.89,7.29c1.4,2.95,2.38,6.17,2.52,9.68c0.14,4.07,0,7.29,0,10.1c0,2.67,0,6.03-0.56,9.4 c-0.56,3.37-1.68,6.31-3.09,9.26c-1.54,2.81-4.21,4.77-6.59,6.59C194.82,117.69,192.3,118.11,189.35,118.11 M192.72,46.15 c-1.96,0-4.07,0.14-5.33,0.14c-2.38,0.14-3.79,0.14-4.35,0.14h-14.31v87.81h16.83c7.43,0,13.61-1.12,18.8-3.23 c5.19-2.1,9.26-5.19,12.48-8.98c3.09-3.79,5.47-8.42,6.87-13.75s2.1-11.08,2.1-17.39c0-8.14,0-14.45-1.54-20.62 c-1.4-5.61-4.35-10.1-7.43-13.47c-2.95-3.37-6.31-5.75-9.82-7.29s-6.87-2.67-10.1-3.23C195.52,46.15,194.12,46.15,192.72,46.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_64_",
    className: "pdf-style-4",
    points: "282.21,46.43 237.74,46.43 237.74,134.24 256.54,134.24 256.54,99.31 280.25,99.31  280.25,83.04 256.54,83.04 256.54,62.7 282.21,62.7 282.21,46.43  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "pdf-style-3",
    d: "M437.21,345.49c-0.14-1.68-1.68-22.02-37.87-21.18c-36.05,0.84-44.89,3.09-44.89,3.09 s-26.93-27.35-36.75-48.53c0,0,11.92-34.93,11.36-56.81c-0.56-21.88-5.75-34.51-22.58-34.37c-16.83,0.14-19.22,14.87-17.11,36.75 c1.96,19.64,12.2,42.78,12.2,42.78s-7.72,24.13-18.1,48.25c-10.24,24.13-17.25,36.75-17.25,36.75s-34.79,11.64-49.8,25.67 s-21.18,24.83-13.33,35.63c6.87,9.26,30.72,11.36,52.18-16.69c21.32-28.05,31-45.59,31-45.59s32.68-8.98,42.78-11.36 c10.1-2.38,22.44-4.35,22.44-4.35s29.74,30.02,58.49,28.9C438.76,363.31,437.35,347.18,437.21,345.49z M210.53,408.76 c-17.81-10.66,37.45-43.63,47.55-44.75C258.08,364.01,229.33,419.98,210.53,408.76z M295.54,216.58c0-17.39,5.61-22.02,9.96-22.02 c4.35,0,9.26,2.1,9.4,17.11c0.14,15.01-9.4,44.47-9.4,44.47C302.27,252.63,295.54,233.84,295.54,216.58z M318.68,335.4 c-17.96,4.35-26.93,8.98-26.93,8.98s0,0,7.29-16.41c7.29-16.41,14.87-38.86,14.87-38.86c10.1,18.94,30.3,41.24,30.3,41.24 S336.64,330.91,318.68,335.4z M361.75,333.85c0,0,58.35-10.52,58.35,9.4C420.1,363.03,383.91,354.89,361.75,333.85z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_44_",
    className: "pdf-style-0",
    points: "401.44,1.4 401.44,108.85 504.55,108.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_21_",
    className: "pdf-style-1",
    points: "402.85,0 402.85,107.45 505.95,107.45  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "pdf-style-5",
    d: "M124.12,86.83c-0.56,0-1.12,0-1.68,0V59.76h3.51c4.07,0,6.59,1.26,8.42,3.37 c2.24,2.52,3.37,7.01,3.37,10.24c0,4.49,0,8.56-4.07,11.5C131.56,86.41,128.05,86.83,124.12,86.83 M127.63,44.89 c-0.14,0-0.42,0-0.56,0c-1.82,0-3.09,0-3.79,0h-19.5v87.81h18.8v-29.6l4.21,0.28c4.35,0,8.28-0.98,11.78-2.1 c3.51-1.12,6.45-3.09,8.98-5.33c2.52-2.24,4.91-5.05,6.17-8.28c1.96-4.91,2.38-11.78,1.96-16.55c-0.56-4.77-0.7-8.7-2.1-11.78 c-1.4-3.09-3.23-5.61-5.33-7.57c-2.24-1.96-4.63-3.37-7.15-4.35c-2.67-0.98-5.05-1.54-7.57-1.96 C131.28,45.03,129.31,44.89,127.63,44.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "pdf-style-5",
    d: "M187.95,116.71c-0.56,0-1.12,0-1.82,0V60.74c0.14,0,0.14,0,0.28,0c3.79,0,8.56,0,10.94,1.96 c2.52,1.96,4.49,4.49,5.89,7.29c1.4,2.95,2.38,6.17,2.52,9.68c0.14,4.07,0,7.29,0,10.1c0,2.67,0,6.03-0.56,9.4 c-0.56,3.37-1.68,6.31-3.09,9.26c-1.54,2.81-4.21,4.77-6.59,6.59C193.42,116.29,190.89,116.71,187.95,116.71 M191.31,44.75 c-1.96,0-4.07,0.14-5.33,0.14c-2.38,0.14-3.79,0.14-4.35,0.14h-14.31v87.81h16.83c7.43,0,13.61-1.12,18.8-3.23 c5.19-2.1,9.26-5.19,12.48-8.98c3.09-3.79,5.47-8.42,6.87-13.75s2.1-11.08,2.1-17.39c0-8.14,0-14.45-1.54-20.62 c-1.4-5.61-4.35-10.1-7.43-13.47c-2.95-3.37-6.31-5.75-9.82-7.29s-6.87-2.67-10.1-3.23C194.12,44.75,192.72,44.75,191.31,44.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_24_",
    className: "pdf-style-5",
    points: "280.81,45.03 236.34,45.03 236.34,132.84 255.14,132.84 255.14,97.91 278.84,97.91  278.84,81.64 255.14,81.64 255.14,61.3 280.81,61.3 280.81,45.03  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PDF-Icon.83eccbff270cacecbfa1ae2bb61671c2.svg";
export { ForwardRef as ReactComponent };